<span
  class="value-wrapper"
  [ngClass]="{
    'invert-colors': invertColors,
    'positive-value': (moneyObject?.value || 0) > 0,
    'negative-value': (moneyObject?.value || 0) < 0
  }"
  >
  @if ((moneyObject?.value || 0) > 0) {
    <em-icon
      [size]="'sm'"
      name="arrow_upward"
      ></em-icon
      >
      }@if ((moneyObject?.value || 0) < 0) {
      <em-icon
        [size]="'sm'"
        name="arrow_downward"
      ></em-icon>
    }
    @if ((moneyObject?.value || 0) > 0) {
      +
      }{{ displayValue }}
    </span>
